export const ACCREDITED_MAP = [
  'skip',
  'individualNetWorth1mm',
  'individualIncome200k',
  'jointIncome300k',
  'entityAccreditedInvestorNetWorth5mm',
  'qualifiedPurchaserNetWorth5mm',
  'qualifiedInstitutionalBuyerNetWorth25mm',
  false,
  'professionalDesignation',
];

export const SIGNUP_STEP_MAP = [
  'create your account',
  'financial situation',
  'invested in farmland',
  'complete your account',
];

export const SIGNUP_SOCIAL_STEP_MAP = [
  'create your account',
  'complete your account',
  'financial situation',
  'invested in farmland',
];
